import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
    setSignalrMessageState (signalRId) {
        return client().put('signalR', null, {params: {signalRId}, loading: false})
    }
}


// WEBPACK FOOTER //
// ./src/repositories/SignalrRepository.js